import { logout } from "../../../../store/slice/authSlice";
import { AppDispatch } from "../../../../store/store";
import "./LeftPanel.scss";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LeftPanel = ({ activeTab }: { activeTab: string }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const onChange = (value: string) => {
    if (value === "deconnection") {
      dispatch(logout());
      toast.success("Déconnecté", {
        className: "toast-success",
      });
      navigate("/");
    } else {
      navigate(`?${value}`, { replace: true });
    }
  };

  const tabs = [
    {
      name: "Informations",
      key: "informations",
    },
    {
      name: "Mes adresses",
      key: "address",
    },
    {
      name: "Historique de mes commandes",
      key: "historique",
    },
    {
      name: "Déconnexion",
      key: "deconnection",
    },
  ];

  return (
    <div className="sidebar">
      <ul>
        {tabs.map((tab, i) => (
          <li
            key={i}
            className={tab.key === activeTab ? "active" : ""}
            onClick={() => onChange(tab.key)}
          >
            {tab.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeftPanel;
